import { render, staticRenderFns } from "./ActivityEvent.vue?vue&type=template&id=6616dc65&scoped=true"
import script from "./ActivityEvent.vue?vue&type=script&lang=js"
export * from "./ActivityEvent.vue?vue&type=script&lang=js"
import style0 from "./ActivityEvent.vue?vue&type=style&index=0&id=6616dc65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6616dc65",
  null
  
)

export default component.exports